export default __webpack_public_path__ + "static/media/res_ins.600a7fb1.PNG";